export default function Minting() {
    return (
        <div id="mintSection" style={{ paddingTop: 50 + 'px' }}>
            {/* <p id="mintMSG">On the NFT platform,<br/>Scarlett Girl will facilitate your destiny.</p> */}
            <p id="mintMSG">Your future in the NFTs<br/>world will be facilitated by Scarlett Girl</p>
            
            <div id="mintCon">
                <button id="mintBtn" className="cur center_it metaportal_fn_button" target="_blank">
                    <span>Connect Wallet & Mint</span>
                </button>
            </div>
        </div>
    )
}